// extracted by mini-css-extract-plugin
module.exports = {"text--content":"text--content__2rR9U"};